import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0028',
    ecrans: ['00-2'],
    params: ['id']
});
